/*
 * rd-product.js
 *
 * Piezas de la página de producto que el JS de Dawn NO puede cubrir, porque
 * Shrine usa un marcado distinto (el Dawn moderno usa data-option-value-id y
 * un elemento <product-info> que Shrine no tiene):
 *
 *   <variant-selects>  selector de variantes (pills, dropdowns, swatches)
 *   <sticky-atc>       botón "Agregar al carrito" fijo
 *
 * El carrito, el drawer, <quantity-input> y <product-form> los maneja el JS de
 * Dawn (cart.js, cart-drawer.js, product-form.js, rd-dawn-core.js).
 */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  /*
   * media-gallery.js (de Dawn) llama a window.pauseAllMedia() al activar una
   * diapositiva. Esa función normalmente la define el global.js de Dawn, pero
   * rd-dawn-core.js (el reemplazo de este tema) no la incluye. Sin ella,
   * media-gallery.js lanzaba un error a mitad de camino y cortaba en seco
   * TODO lo que rd-product.js hacía después de mover la imagen: no solo el
   * detalle de la miniatura activa, sino que además dejaba sin ejecutar
   * updateLabels() (el rótulo "Color: ..." nunca se actualizaba). La
   * definimos aquí para que ese error deje de ocurrir.
   */
  if (typeof window.pauseAllMedia !== 'function') {
    window.pauseAllMedia = function () {
      document.querySelectorAll('video').forEach(function (video) {
        if (typeof video.pause === 'function') video.pause();
      });
      document.querySelectorAll('product-model[loaded]').forEach(function (model) {
        if (model.modelViewerUI && typeof model.modelViewerUI.pause === 'function') {
          model.modelViewerUI.pause();
        }
      });
    };
  }

  function defineVariantSelects() {
    if (customElements.get('variant-selects')) return;

    customElements.define(
      'variant-selects',
      class extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.variants = this.readVariants();
          if (!this.variants.length) return;

          this.labelInfo = this.readLabelInfo();

          this.addEventListener('change', this.onChange.bind(this));
          this.apply(false);
        }

        readVariants() {
          var tag = this.querySelector('script[type="application/json"]');
          if (!tag) return [];
          try {
            return JSON.parse(tag.textContent);
          } catch (e) {
            console.error('[rd-product] variantes ilegibles:', e);
            return [];
          }
        }

        /*
         * Guardamos, para cada opción (Color, Talla, etc.), el elemento del
         * rótulo personalizado y el valor que Liquid dejó renderizado la
         * primera vez. Shrine repite ese valor más de una vez dentro del
         * mismo <span> (una vez dentro del texto "Color:  1 par Negro" y
         * otra vez suelto al final, probablemente para lectores de pantalla),
         * así que no basta con cortar el final: hay que reemplazar TODAS las
         * apariciones del valor anterior.
         */
        readLabelInfo() {
          var sectionId = this.sectionId;
          return this.optionGroups().map(function (group, i) {
            var span = document.getElementById('custom-label-' + sectionId + '-' + (i + 1));
            if (!span) return null;

            var select = group.querySelector('select[name^="options"]');
            var checkedRadio = group.querySelector('input[type="radio"]:checked');
            var initialValue = select ? select.value : checkedRadio ? checkedRadio.value : '';

            return { span: span, lastValue: initialValue };
          });
        }

        /*
         * EL ARREGLO: el rótulo ("Color:  1 par Negro") no se actualizaba al
         * elegir otra variante porque nada tocaba ese texto tras el cambio.
         * Reemplazamos cada aparición del valor anterior por el nuevo,
         * dentro del mismo texto (en vez de reconstruirlo desde cero, para no
         * perder el formato "[name]: [selected]" configurado en el bloque).
         */
        updateLabels() {
          if (!this.labelInfo) return;
          var selected = this.selectedOptions();
          this.labelInfo.forEach(function (info, i) {
            if (!info || selected[i] === undefined) return;
            var newValue = selected[i];
            if (newValue === info.lastValue) return;
            if (info.lastValue) {
              info.span.textContent = info.span.textContent.split(info.lastValue).join(newValue);
            }
            info.lastValue = newValue;
          });
        }

        optionGroups() {
          return Array.prototype.filter.call(
            this.querySelectorAll('.product-form__input'),
            function (group) {
              if (group.classList.contains('product-form__input--quantity-breaks')) return false;
              return !!(
                group.querySelector('select[name^="options"]') ||
                group.querySelector('input[type="radio"]')
              );
            }
          );
        }

        selectedOptions() {
          return this.optionGroups()
            .map(function (group) {
              var select = group.querySelector('select[name^="options"]');
              if (select) return select.value;
              var radio = group.querySelector('input[type="radio"]:checked');
              return radio ? radio.value : null;
            })
            .filter(function (value) {
              return value !== null;
            });
        }

        matchVariant() {
          var chosen = this.selectedOptions();
          if (!chosen.length) return null;

          return (
            this.variants.find(function (variant) {
              return chosen.every(function (value, i) {
                return variant.options[i] === value;
              });
            }) || null
          );
        }

        onChange() {
          this.apply(true);
        }

        apply(userDriven) {
          var variant = this.matchVariant();

          if (!variant) return;

          this.writeVariantId(variant);
          this.setAvailability(variant);
          this.updateMedia(variant);
          this.updateLabels();

          if (!userDriven) return;

          if (this.dataset.updateUrl !== 'false') {
            window.history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
          }
          this.refreshPrice(variant);
        }

        writeVariantId(variant) {
          document.querySelectorAll('.product-variant-id').forEach(function (input) {
            input.value = variant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        setAvailability(variant) {
          if (!variant.available) return;

          var buttons = document.querySelectorAll(
            '#ProductForm-' + this.sectionId + ' [type="submit"], ' +
              '#sticky-atc-' + this.sectionId + ' button[type="submit"]'
          );

          buttons.forEach(function (button) {
            button.disabled = false;
            button.removeAttribute('disabled');
            button.removeAttribute('aria-disabled');
          });
        }

        /*
         * Cambia la imagen destacada de la galería a la de la variante elegida.
         * media-gallery.js ya sabe activar una diapositiva por su
         * data-media-id="{sectionId}-{mediaId}"; solo faltaba avisarle qué
         * media mostrar al cambiar de variante. Sin esto, la imagen nunca se
         * movía: ese era el bug reportado.
         */
        updateMedia(variant) {
          if (!variant.featured_media) return;

          var mediaId = this.sectionId + '-' + variant.featured_media.id;

          document
            .querySelectorAll('media-gallery[data-section="' + this.sectionId + '"]')
            .forEach(function (gallery) {
              if (typeof gallery.setActiveMedia !== 'function') return;
              // Blindado: si media-gallery.js falla a mitad de camino (por
              // ejemplo por un helper que falte), no debe cortar el resto de
              // apply() (etiqueta, disponibilidad, precio).
              try {
                gallery.setActiveMedia(mediaId, true);
              } catch (e) {
                console.error('[rd-product] galería:', e);
              }
            });
        }

        refreshPrice(variant) {
          var url = this.dataset.url + '?variant=' + variant.id + '&section_id=' + this.sectionId;

          fetch(url)
            .then(function (res) { return res.text(); })
            .then(
              function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                ['price-', 'sticky-atc-price-', 'sticky-atc-separate-price-'].forEach(
                  function (prefix) {
                    var id = prefix + this.sectionId;
                    var fresh = doc.getElementById(id);
                    var current = document.getElementById(id);
                    if (fresh && current) current.innerHTML = fresh.innerHTML;
                  }.bind(this)
                );
              }.bind(this)
            )
            .catch(function (err) {
              console.error('[rd-product] precio:', err);
            });
        }
      }
    );
  }

  function defineStickyAtc() {
    if (customElements.get('sticky-atc')) return;

    customElements.define(
      'sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;

          this.addEventListener('change', this.mirrorToMainPicker.bind(this));

          var button = this.querySelector('button');
          if (button) button.addEventListener('click', this.onClick.bind(this));

          if (this.dataset.afterScroll === 'true') {
            this.mainButton = document.querySelector(
              '#ProductForm-' + this.sectionId + ' [type="submit"]'
            );
            this.handleScroll = this.handleScroll.bind(this);
            window.addEventListener('scroll', this.handleScroll, { passive: true });
            this.handleScroll();
          }
        }

        disconnectedCallback() {
          if (this.handleScroll) window.removeEventListener('scroll', this.handleScroll);
        }

        handleScroll() {
          if (!this.mainButton) return;
          var passed = this.mainButton.getBoundingClientRect().bottom < 0;
          this.dataset.afterScroll = passed ? 'false' : 'true';
        }

        mirrorToMainPicker(event) {
          var picker = document.getElementById('variant-selects-' + this.sectionId);
          if (!picker) return;

          var value = event.target.value;
          var changed = false;

          picker.querySelectorAll('.product-form__input').forEach(function (group) {
            var select = group.querySelector('select[name^="options"]');
            if (select) {
              var exists = Array.prototype.some.call(select.options, function (option) {
                return option.value === value;
              });
              if (exists && select.value !== value) {
                select.value = value;
                changed = true;
              }
              return;
            }
            group.querySelectorAll('input[type="radio"]').forEach(function (radio) {
              if (radio.value === value && !radio.checked) {
                radio.checked = true;
                changed = true;
              }
            });
          });

          if (changed) picker.dispatchEvent(new Event('change', { bubbles: true }));
        }

        onClick(event) {
          if (this.dataset.scrollBtn === 'true') {
            event.preventDefault();
            this.scrollToDestination();
            return;
          }

          event.preventDefault();
          var main = document.querySelector('#ProductForm-' + this.sectionId + ' [type="submit"]');
          if (main) main.click();
        }

        scrollToDestination() {
          var map = {
            product_information: '#ProductInfo-' + this.sectionId,
            variant_picker: '#variant-selects-' + this.sectionId,
            quantity_breaks: '.product-form__input--quantity-breaks',
            pricing_table: '.quantity-breaks'
          };
          var target = document.querySelector(map[this.dataset.scrollDestination] || '');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    );
  }

  var CHECKOUT_URL = '/checkout';

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function showFormError(productForm, message) {
    var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    var text = productForm.querySelector('.product-form__error-message');
    if (wrapper && text) {
      text.textContent = message;
      wrapper.removeAttribute('hidden');
    } else {
      console.error('[rd-product]', message);
    }
  }

  function addThenCheckout(productForm, form, button) {
    if (button) button.classList.add('loading');

    return fetch(cartAddUrl() + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showFormError(
            productForm,
            result.json.description || result.json.message || 'No se pudo agregar al carrito.'
          );
          if (button) button.classList.remove('loading');
          return;
        }
        window.location.href = CHECKOUT_URL;
      })
      .catch(function (err) {
        console.error('[rd-product] skip cart:', err);
        showFormError(productForm, 'No se pudo procesar la compra. Inténtalo de nuevo.');
        if (button) button.classList.remove('loading');
      });
  }

  function initSkipCart() {
    document.addEventListener('click', function (event) {
      var button =
        event.target.closest && event.target.closest('[data-skip-cart-button="true"]');
      if (!button || button.disabled) return;

      var productForm = button.closest('product-form');
      var form = productForm && productForm.querySelector('form');
      if (!form) return;

      event.preventDefault();
      addThenCheckout(productForm, form, button);
    });

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var idInput = form.querySelector('.product-variant-id[data-skip-cart="true"]');
        if (!idInput) return;

        var productForm = form.closest('product-form');
        if (!productForm) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        addThenCheckout(productForm, form, form.querySelector('[type="submit"]'));
      },
      true
    );
  }

  defineVariantSelects();
  defineStickyAtc();
  initSkipCart();
})();
